<div id="layout-wrapper" (window:resize)="onResize($event)">
    <!-- Top Bar -->
    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
    <!-- Side Bar -->
    @if(issemiboxLayoutRequested()){
        <app-sidebar></app-sidebar>
    }
 
    @if(isTwoColumnLayoutRequested()){
    <app-two-column-sidebar></app-two-column-sidebar>
    }
    <div class="main-content">
        <div class="page-content" style="margin-top: 0px;padding-top: 0px;">
            <div class="container-fluid">
                <!-- Main Content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- Footer -->
        <app-footer></app-footer>
    </div>
  </div>
  <!-- Right Side Bar -->
  <app-rightsidebar (settingsButtonClicked)="onSettingsButtonClicked()"></app-rightsidebar>
  